import { validators } from './validators';

// Funções de formatação para o sistema MeuFiel
export const formatters = {
  // Criar timestamp atual (sem ajuste de fuso, deixa o Firebase/formatação cuidar)
  getCurrentTimestamp: () => {
    return new Date().toISOString();
  },

  // Formatação de CPF
  formatCpf: (cpf) => {
    if (!cpf) return '';
    const cleanCpf = cpf.replace(/[^\d]/g, '');
    
    if (cleanCpf.length <= 3) return cleanCpf;
    if (cleanCpf.length <= 6) return `${cleanCpf.slice(0, 3)}.${cleanCpf.slice(3)}`;
    if (cleanCpf.length <= 9) return `${cleanCpf.slice(0, 3)}.${cleanCpf.slice(3, 6)}.${cleanCpf.slice(6)}`;
    return `${cleanCpf.slice(0, 3)}.${cleanCpf.slice(3, 6)}.${cleanCpf.slice(6, 9)}-${cleanCpf.slice(9, 11)}`;
  },

  // Formatação de CNPJ
  formatCnpj: (cnpj) => {
    if (!cnpj) return '';
    const cleanCnpj = cnpj.replace(/[^\d]/g, '');
    
    if (cleanCnpj.length <= 2) return cleanCnpj;
    if (cleanCnpj.length <= 5) return `${cleanCnpj.slice(0, 2)}.${cleanCnpj.slice(2)}`;
    if (cleanCnpj.length <= 8) return `${cleanCnpj.slice(0, 2)}.${cleanCnpj.slice(2, 5)}.${cleanCnpj.slice(5)}`;
    if (cleanCnpj.length <= 12) return `${cleanCnpj.slice(0, 2)}.${cleanCnpj.slice(2, 5)}.${cleanCnpj.slice(5, 8)}/${cleanCnpj.slice(8)}`;
    return `${cleanCnpj.slice(0, 2)}.${cleanCnpj.slice(2, 5)}.${cleanCnpj.slice(5, 8)}/${cleanCnpj.slice(8, 12)}-${cleanCnpj.slice(12, 14)}`;
  },

  // Formatação automática de CPF ou CNPJ
  formatCpfOrCnpj: (document) => {
    if (!document) return '';
    const cleanDoc = document.replace(/[^\d]/g, '');
    
    if (cleanDoc.length <= 11) {
      return formatters.formatCpf(document);
    } else {
      return formatters.formatCnpj(document);
    }
  },

  // Limpeza de CPF ou CNPJ (remove formatação)
  cleanCpfOrCnpj: (document) => {
    if (!document) return '';
    return document.replace(/[^\d]/g, '');
  },

  // Limpeza de CPF (remove formatação)
  cleanCpf: (cpf) => {
    if (!cpf) return '';
    return cpf.replace(/[^\d]/g, '');
  },

  // Formatação de data (YYYY-MM-DD para DD/MM/YYYY)
  formatDate: (date) => {
    if (!date) return '-';
    
    try {
      let dateObj;
      
      // Se é uma string ISO (formato do Firebase)
      if (typeof date === 'string') {
        // Se a string está vazia ou inválida
        if (date.trim() === '') return '-';
        dateObj = new Date(date);
      }
      // Se é um Timestamp do Firebase/Firestore
      else if (date && typeof date.toDate === 'function') {
        dateObj = date.toDate();
      }
      // Se é um objeto com propriedade seconds (Firestore Timestamp)
      else if (date && typeof date.seconds === 'number') {
        dateObj = new Date(date.seconds * 1000);
      }
      // Se é um objeto Date
      else if (date instanceof Date) {
        dateObj = date;
      }
      // Se é um número (timestamp em millisegundos)
      else if (typeof date === 'number') {
        dateObj = new Date(date);
      }
      else {
        console.warn('Formato de data não reconhecido:', date);
        return '-';
      }
      
      // Verificar se a data é válida
      if (!dateObj || isNaN(dateObj.getTime())) {
        console.warn('Data inválida:', date);
        return '-';
      }
      
      return dateObj.toLocaleDateString('pt-BR', {
        timeZone: 'America/Sao_Paulo'
      });
    } catch (error) {
      console.error('Erro ao formatar data:', error, 'Data original:', date);
      return '-';
    }
  },

  // Formatação de data e hora
  formatDateTime: (date) => {
    if (!date) return '';
    try {
      let dateObj;
      
      // Se é uma string ISO (formato do Firebase)
      if (typeof date === 'string') {
        dateObj = new Date(date);
      }
      // Se é um Timestamp do Firebase
      else if (date.toDate && typeof date.toDate === 'function') {
        dateObj = date.toDate();
      }
      // Se é um objeto Date
      else if (date instanceof Date) {
        dateObj = date;
      }
      // Se é um número (timestamp)
      else if (typeof date === 'number') {
        dateObj = new Date(date);
      }
      else {
        return '';
      }
      
      // Verificar se a data é válida
      if (isNaN(dateObj.getTime())) {
        return '';
      }
      
      return dateObj.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo'
      });
    } catch (error) {
      console.error('Erro ao formatar data e hora:', error, date);
      return '';
    }
  },

  // Formatação de telefone
  formatPhone: (phone) => {
    if (!phone) return '';
    const cleanPhone = phone.replace(/[^\d]/g, '');
    
    if (cleanPhone.length <= 2) return cleanPhone;
    if (cleanPhone.length <= 6) return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(2)}`;
    if (cleanPhone.length <= 10) return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(2, 6)}-${cleanPhone.slice(6)}`;
    return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(2, 7)}-${cleanPhone.slice(7, 11)}`;
  },

  // Limpeza de telefone (remove formatação)
  cleanPhone: (phone) => {
    if (!phone) return '';
    return phone.replace(/[^\d]/g, '');
  },

  // Formatação de CEP
  formatCep: (cep) => {
    if (!cep) return '';
    const cleanCep = cep.replace(/[^\d]/g, '');
    
    if (cleanCep.length <= 5) return cleanCep;
    return `${cleanCep.slice(0, 5)}-${cleanCep.slice(5, 8)}`;
  },

  // Formatação de moeda (Real brasileiro)
  formatCurrency: (value) => {
    if (value === null || value === undefined || isNaN(value)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  },

  // Formatação de números
  formatNumber: (number) => {
    if (number === null || number === undefined || isNaN(number)) return '0';
    return new Intl.NumberFormat('pt-BR').format(number);
  },

  // Formatação de pontos
  formatPoints: (points) => {
    if (points === null || points === undefined || isNaN(points)) return '0 pontos';
    const formattedNumber = formatters.formatNumber(points);
    return `${formattedNumber} ${points === 1 ? 'ponto' : 'pontos'}`;
  },

  // Formatação de nome (primeira letra maiúscula)
  formatName: (name) => {
    if (!name || typeof name !== 'string') return '';
    return name.trim()
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  },

  // Formatação de email (remove espaços e converte para minúsculo)
  formatEmail: (email) => {
    if (!email || typeof email !== 'string') return '';
    return email.trim().toLowerCase();
  },

  // Formatação de status
  formatStatus: (status) => {
    const statusMap = {
      active: 'Ativo',
      inactive: 'Inativo',
      pending: 'Pendente',
      blocked: 'Bloqueado',
      true: 'Ativo',
      false: 'Inativo'
    };
    return statusMap[status] || status;
  },

  // Formatação de tipo de transação
  formatTransactionType: (type) => {
    const typeMap = {
      add: 'Adição',
      redeem: 'Resgate',
      bonus: 'Bônus',
      penalty: 'Penalidade'
    };
    return typeMap[type] || type;
  },

  // Truncar texto com reticências
  truncateText: (text, maxLength = 50) => {
    if (!text || typeof text !== 'string') return '';
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength).trim() + '...';
  },

  // Extrair iniciais do nome
  getInitials: (name) => {
    if (!name || typeof name !== 'string') return '';
    return name.trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2);
  },

  // Formatação de endereço (string ou objeto)
  formatAddress: (address) => {
    if (!address) return '';
    
    // Se é uma string simples, retorna como está
    if (typeof address === 'string') {
      return address;
    }
    
    // Se é um objeto estruturado
    if (typeof address === 'object') {
      const parts = [];
      
      if (address.street) parts.push(address.street);
      if (address.number) parts.push(address.number);
      if (address.complement) parts.push(address.complement);
      if (address.city) parts.push(address.city);
      if (address.state) parts.push(address.state);
      if (address.cep) parts.push(`CEP: ${address.cep}`);
      
      return parts.filter(Boolean).join(', ');
    }
    
    return '';
  },

  // Formatação de data para input do tipo date (mantém timezone local)
  formatDateForInput: (date) => {
    if (!date) return '';
    
    try {
      let dateObj;
      
      // Se é uma string (formato ISO ou DD/MM/YYYY)
      if (typeof date === 'string') {
        if (date.trim() === '') return '';
        
        // Se está no formato DD/MM/YYYY, converte para YYYY-MM-DD
        if (date.includes('/')) {
          const [day, month, year] = date.split('/');
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        
        // Se já está no formato YYYY-MM-DD, retorna como está
        if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return date;
        }
        
        // Para strings ISO, cria a data
        dateObj = new Date(date);
      }
      // Se é um Timestamp do Firebase/Firestore
      else if (date && typeof date.toDate === 'function') {
        dateObj = date.toDate();
      }
      // Se é um objeto com propriedade seconds (Firestore Timestamp)
      else if (date && typeof date.seconds === 'number') {
        dateObj = new Date(date.seconds * 1000);
      }
      // Se é um objeto Date
      else if (date instanceof Date) {
        dateObj = date;
      }
      else {
        return '';
      }
      
      // Verifica se a data é válida
      if (isNaN(dateObj.getTime())) return '';
      
      // Retorna no formato YYYY-MM-DD usando timezone local
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error('Erro ao formatar data para input:', error);
      return '';
    }
  },

  // Converte data do input (YYYY-MM-DD) para Date object no meio-dia local
  parseDateFromInput: (dateString) => {
    if (!dateString || typeof dateString !== 'string') return null;
    
    try {
      // Se está no formato YYYY-MM-DD (padrão do input date)
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateString.split('-');
        // Cria a data no meio-dia (12:00) do timezone local para evitar problemas de conversão
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 12, 0, 0, 0);
      }
      
      return null;
    } catch (error) {
      console.error('Erro ao converter data do input:', error);
      return null;
    }
  }
};

// Exportar também as validações junto com os formatters para conveniência
export { validators } from './validators';